import React, { Fragment, Component } from "react";
import $ from "jquery";
import "jquery-ui";
import "jquery-ui-dist/jquery-ui";
import ReactDOM from "react-dom";
import DragItem from "../../ddTxtImg/model/DragItem";
import DropItem from "../model/DropItem";

class DDPDropContainer extends Component {
  componentDidMount = () => {
    window.x(this.txt);

    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { dropItemContainer } = activity;

    // console.log("dropItemContainer Length : " + dropItemContainer.dropItemLength)  

    // console.log("dropItemContainer.dropItemList.length > 0)")
    // console.log(dropItemContainer.dropItemList.length > 0)
    if (dropItemContainer.dropItemList.length > 0) {
      for (let i = 0; i < dropItemContainer.dropItemList.length; i++) {
        let dropItemId = "dropItem" + dropItemContainer.activityId + "_" + i;
        // console.log(dropItemId)
        dropItemContainer.dropItemList[i].dropItem =
          document.getElementById(dropItemId);
        dropItemContainer.dropItemList[i].initDropItem(activity);
      }
    } else {
      for (let i = 0; i < dropItemContainer.dropItemLength; i++) {
        let dropItemId = "dropItem" + dropItemContainer.activityId + "_" + i;
        let dropItem = new DropItem();
        dropItem.dropItem = document.getElementById(dropItemId);

        dropItem.dragList = dropItemContainer.getDragListFromIndexString(
          dropItem.dropItem.getAttribute("data-index"),
          activity.dragContainerModel.dragItemList
        );

        dropItemContainer.dropItemList.push(dropItem);
        dropItem.initDropItem(activity);
      }
    }
  };

  componentWillReceiveProps = (props) => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { dropItemContainer } = activity;

    // console.log("componentWillReceiveProps")
    // console.log(quizViwerModel.reviewMode)
    if (quizViwerModel.reviewMode) {
      let { dropItemList } = dropItemContainer;
      // console.log(dropItemList)
      for (let i = 0; i < dropItemList; i++) {
        if (this.checkDropItemSolution(dropItemList[i])) {
          dropItemList[i].style.color = "green";
        } else {
          dropItemList[i].style.color = "red";
        }
      }
    }
  };

  render = () => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { dropItemContainer } = activity;
    let { selectedStyle } = dropItemContainer;

    return (
      <Fragment>
        <div

        //  style={(selectedStyle!=null)?selectedStyle[0].style:{}}
        >
          {
            <div

            //  style={(selectedStyle!=null)?selectedStyle[1].style:{}}
            >
              <table style={{ width: "100%", height: "90%" }}>
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: "center",
                        verticalAlign: "middle",
                        direction: "rtl",
                        padding: "5px",
                      }}
                      ref={(el) => (this.txt = el)}
                      dangerouslySetInnerHTML={{
                        __html: dropItemContainer.paragraphTxt,
                      }}
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
      </Fragment>
    );
  };

  handlePrevStyle = () => {
    let { activity, quizViewer } = this.props;
    let { dropItemContainer } = activity;
    dropItemContainer.prevStyle();
    quizViewer.setState({});
  };

  handleNextStyle = () => {
    let { activity, quizViewer } = this.props;
    let { dropItemContainer } = activity;
    dropItemContainer.nextStyle();
    quizViewer.setState({});
  };

  handleTxtChange = (e) => {
    let { activity, quizViewer } = this.props;
    let { dropItemContainer } = activity;
    dropItemContainer.paragraphTxt = e.target.innerHTML;
  };
}

export default DDPDropContainer;
